import { AppState } from '@Redux/store';

export const getUserBugReportLoading = (state: AppState): boolean =>
  state.userBugReport.isLoading ?? false;
